import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Content from './Content';

const Container = ({ children }) => <PerfectScrollbar>{children}</PerfectScrollbar>;

Container.Content = Content;
export default Container;
